/** @module api/target_access_permissions */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemPermissionTargetsPath,
  apiV1EnergyManagementSystemTargetAccessPermissionsPath,
  purgeApiV1EnergyManagementSystemTargetAccessPermissionsPath
} from '@/../lib/routes'

export function getTargetAccessPermissions({ ctxt = 'customer', emsId, userIds }) {
  const filter = {}
  if (userIds && userIds.length > 0) filter.userIds = userIds.join(',')

  const payload = { filter }

  return apiCall({
    path: apiV1EnergyManagementSystemTargetAccessPermissionsPath(ctxt, emsId),
    payload
  })
}

export function getPermissionTargets({ ctxt = 'customer', emsId, locale = 'en' }) {
  const payload = { locale }

  return apiCall({
    path: apiV1EnergyManagementSystemPermissionTargetsPath(ctxt, emsId),
    payload
  })
}

export function updateTargetAccessPermissions({ ctxt = 'customer', emsId, payload }) {
  return apiCall({
    method: 'POST',
    path: apiV1EnergyManagementSystemTargetAccessPermissionsPath(ctxt, emsId),
    payload
  })
}

export function purgeTargetAccessPermissions({ ctxt = 'customer', emsId, payload }) {
  return apiCall({
    method: 'POST',
    path: purgeApiV1EnergyManagementSystemTargetAccessPermissionsPath(ctxt, emsId),
    payload
  })
}
